import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import config from '@/config'

Vue.use(Vuetify)

// With below commented, it currently show conficting order for vuetify components.
// If uncomment, the warnings disappear but the entrypoint size increases, which is not wanted.
// TODO see how to become rid of these warnings without increasing the entrypoint size

// import Vuetify, {
//   VCard,
//   VChip,
//   VCounter,
//   VInput,
//   VLabel,
//   VMessages,
//   VProgressLinear,
//   VSelect,
//   VSimpleCheckbox,
//   VSubheader,
//   VTextField
// } from 'vuetify/lib';
// import config from '@/config'

// Vue.use(Vuetify, {
//   components: {
//     VCard,
//     VChip,
//     VCounter,
//     VInput,
//     VLabel,
//     VMessages,
//     VProgressLinear,
//     VSelect,
//     VSimpleCheckbox,
//     VSubheader,
//     VTextField
//   }
// });

export default new Vuetify({
  breakpoint: {
    thresholds: {
      md: 1415
    }
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      dark: config.dark,
      light: config.light,
    }
  },
  icons: {
    iconfont: 'md'
  }
});
